import { useFormApi } from 'informed';
import { ApplicationData } from '../../../../types/TymbeApi';
import { AttendanceResolution } from '@tymbe/schema/enums';
import UnapprovedAttendanceRow from './UnapprovedAttendanceRow';
import { BadgePill } from '@tymbe/ty-components/indicators';
import Spinner from '@tymbe/ty-components/indicators/Spinner';

type ShiftAttendanceProps = {
  applications: ApplicationData[];
  startDate: string;
  endDate: string;
  onSubmit: (values: AttendanceScope[]) => Promise<unknown> | void;
  isLoading?: boolean;
};

export type AttendanceScope = {
  id: number;
  confirmed_time: number;
  break: number;
  start: number;
  end: number;
  rating: number;
  selected: boolean;
  resolution: AttendanceResolution;
};

export type FormValues = {
  applications: AttendanceScope[];
 }

const ShiftUnapprovedAttendance = ({
  applications,
  startDate,
  endDate,
  onSubmit,
  isLoading = false,
}: ShiftAttendanceProps) => {
  const formApi = useFormApi();

  const submitSingle = async (key: number) => {
    const values: AttendanceScope = formApi?.getValue(`applications.${key}`);
    if (!values) return;
    try {
      await onSubmit([values]);
    } catch {
      /* can be safely ignored */
    }
  };

  return (
    <div className="flex flex-col">
      <div className="grid grid-cols-[25%_auto_25%] gap-4 p-4 bg-white rounded-xl">
        <div className="flex items-center gap-2">
          <span className="text-secondary-600 text-body-2-xl font-semibold">
            Docházka k potvrzení
          </span>
          <BadgePill variant="info">{applications.length}</BadgePill>
        </div>
        <div className="flex gap-6 text-nowrap text-body-2-xl font-normal">
          <div className="flex gap-6 w-48">
            <span>Odpracováno</span>
            <span>Přestávka</span>
          </div>
          <span>Příchod a odchod</span>
        </div>
        <div>{isLoading && <Spinner color="secondary-600" className="w-5 h-5" />}</div>
      </div>
      {applications.length ? (
        <div className="rounded-2xl border border-secondary-transparent-10 bg-white divide-y divide-secondary-transparent-10">
          {applications.map((application) => (
            <UnapprovedAttendanceRow
              key={application.id}
              application={application}
              submitSingle={submitSingle}
              startDate={startDate}
              endDate={endDate}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default ShiftUnapprovedAttendance;
